import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import { KIOSK_PRO_MEDIA } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';

export function QrCodeLogin({
  consumerPhoneLoginUrl,
  className,
  size = 220,
}: {
  consumerPhoneLoginUrl: string;
  className?: string;
  size?: number;
}): JSX.Element {
  return (
    <QrCodeContainer className={className}>
      <QrCodeContent data-testid='qr-code' value={consumerPhoneLoginUrl} size={size} marginSize={2} />
      <QrcodeSubtitle>
        Scan to login
        <br />
        on your phone
      </QrcodeSubtitle>
    </QrCodeContainer>
  );
}

const QrCodeContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

const QrCodeContent = styled(QRCodeSVG)`
  border: 6px solid ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  border-radius: 16px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 156px;
    height: 156px;
  }
`;

const QrcodeSubtitle = styled.p`
  margin-top: 36px;
  font-size: clamp(20px, 3vw, 24px);
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
  }
`;
